module.exports = __webpack_public_path__ + "img/chair.be5030ca.webp";